import type { RootState } from 'js/src/libs/RootState';

export const getAudioEnhancementStatusForSceneGroup = (state: RootState, sceneGroupId: string) => {
    const audioEnhancementStatus =
        state.audio_enhancement.audio_enhancement_status.get(sceneGroupId);
    return audioEnhancementStatus;
};

export const getIsAudioEnhancementLoadingForSceneGroup = (
    state: RootState,
    sceneGroupId: string,
): boolean | undefined => {
    return state.audio_enhancement.AUDIO_ENHANCEMENT_LOADING.get(sceneGroupId)?.get('isLoading') as
        | boolean
        | undefined;
};

export const getAudioEnhancementLoadingAbortController = (
    state: RootState,
    sceneGroupId: string,
): AbortController | undefined => {
    return state.audio_enhancement.AUDIO_ENHANCEMENT_LOADING.get(sceneGroupId)?.get(
        'abortController',
    ) as AbortController | undefined;
};
